import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "../../../components/common/loader/Loader";

export default function GameStatus(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const [idGame, setIdGame] = React.useState(0);
  const [sportType, setSportType] = React.useState(0);
  const [shortGame, setShortGame] = React.useState(0);
  const [gameStatus, setGameStatus] = React.useState("");
  const [contenderStatus, setContenderStatus] = React.useState(0);
  const [system, setSystem] = React.useState(0);
  const [sendToLS, setSendToLS] = React.useState(false);
  const [hideGame, setHideGame] = React.useState(false);
  const [noHookUps, setNoHookUps] = React.useState(false);
  const [boldSpread, setBoldSpread] = React.useState(false);
  const [boldTotal, setBoldTotal] = React.useState(false);
  const [boldML, setBoldML] = React.useState(false);
  const [syncSpread, setSyncSpread] = React.useState(false);
  const [syncTotal, setSyncTotal] = React.useState(false);
  const [syncSpreadOdds, setSyncSpreadOdds] = React.useState(false);
  const [syncTotalOdds, setSyncTotalOdds] = React.useState(false);
  const [syncML, setSyncML] = React.useState(false);
  const [completedGame, setCompletedGame] = React.useState("");
  const [homeNumber, setHomeNumber] = React.useState(0);
  const [homeTeam, setHomeTeam] = React.useState(0);
  const [homeScore, setHomeScore] = React.useState(0);
  const [visitorNumber, setVisitorNumber] = React.useState(0);
  const [visitorTeam, setVisitorTeam] = React.useState(0);
  const [visitorScore, setVisitorScore] = React.useState(0);
  const [idUser, setIdUser] = React.useState(0);
  const [result, setResult] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [selectedValueTime, setSelectedValueTime] = React.useState("None");
  const [gamesTNT, setGamesTNT] = React.useState("None");
  const [selectedIdProfile, setSelectedIdProfile] = useState(props.rotation);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedValueStatus, setSelectedValueStatus] =
    React.useState("Visitor");
  const [flag, setFlag] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const [selectedValueAutoChanges, setSelectedValueAutoChanges] =
    React.useState("Visitor");

  const handleChangeSendToLS = () => {
    setSendToLS(!sendToLS);
  };
  const handleChangeHideGame = () => {
    setHideGame(!hideGame);
  };
  const handleChangeBoldSpreadChanged = () => {
    setBoldSpread(!boldSpread);
  };
  const handleChangeBoldTotalChanged = () => {
    setBoldTotal(!boldTotal);
  };
  const handleChangeBoldMLChanges = () => {
    setBoldML(!boldML);
  };

  const handleChangeAllowSpreadChanges = () => {
    setSyncSpread(!syncSpread);
  };

  const handleChangeAllowTotalChanges = () => {
    setSyncTotal(!syncTotal);
  };

  const handleChangeAllowSpreadOddsChanges = () => {
    setSyncSpreadOdds(!syncSpreadOdds);
  };

  const handleChangeAllowTotalOddsChanges = () => {
    setSyncTotalOdds(!syncTotalOdds);
  };

  const handleChangeAllowMLChanges = () => {
    setSyncML(!syncML);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };

  useEffect(() => {
    console.log(props)
  }, [])

  const handleOk = async () => {
    setIsLoading(true);

    // Crear el array de requests
    const requests = props.IdGame.map((idGame) => ({
      IdLineType: props.IdLinetype,
      IdGame: idGame,
      SendToLS: sendToLS,
      HideGame: hideGame,
      SyncSpread: syncSpread,
      SyncSpreadOdds: syncSpreadOdds,
      SyncTotal: syncTotal,
      SyncTotalOdds: syncTotalOdds,
      SyncML: syncML,
      BoldSpread: boldSpread,
      BoldTotal: boldTotal,
      BoldML: boldML,
      SystemID: "N",
      IdUser: userInfo.userId,
    }));

    console.log("props GameValues_ChangeSettings ====>", requests);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API2_URL}/Game/GameValues_ChangeSettings`,
        requests
      );
      console.log("response", response);

      props.searchGameValues();
      props.clearArray();
      props.onClose();
    } catch (error) {
      console.error("Error al enviar los cambios:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      "/Game/GetGameValuesByGameAndLine?idGame=" +
      props.IdGame[0] +
      "&idLineType=" +
      props.IdLinetype;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setSendToLS(data.sendToLS);
        setHideGame(data.hideGame);
        setBoldSpread(data.boldSpread);
        setBoldTotal(data.boldTotal);
        setBoldML(data.boldML);
        setSyncSpread(data.syncSpreadPoints);
        setSyncTotal(data.syncTotalPoints);
        setSyncSpreadOdds(data.syncSpreadOdds);
        setSyncTotalOdds(data.syncTotalOdds);
        setSyncML(data.syncML);

        setLoading(false);
      }); setLoading(false);
  }, []);

  return (
    <Dialog open={open} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Settings Game
          </Typography>
        </Toolbar>
      </AppBar>
      {loading ? (
        <CircularProgress style={{ margin: "0 auto" }} />
      ) : (
        <React.Fragment>
          <br />
          <form className={classes.center}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={sendToLS}
                    onChange={handleChangeSendToLS}
                    color="primary"
                  />
                }
                label="Send Line Changes to line service"
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={hideGame}
                    onChange={handleChangeHideGame}
                    color="primary"
                  />
                }
                label="Hide Game in this line type "
              />
            </FormGroup>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={boldSpread}
                    onChange={handleChangeBoldSpreadChanged}
                    color="primary"
                  />
                }
                label="Bold Spread"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={boldTotal}
                    onChange={handleChangeBoldTotalChanged}
                    color="primary"
                  />
                }
                label="Bold Total"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={boldML}
                    onChange={handleChangeBoldMLChanges}
                    color="primary"
                  />
                }
                label="Bold Money Line"
              />
            </FormGroup>
            <Divider />
            <p>INCOMING Line Changes(from other line types)</p>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={syncSpread}
                    onChange={handleChangeAllowSpreadChanges}
                    color="primary"
                  />
                }
                label="Allow Point-Spread Changes"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={syncTotal}
                    onChange={handleChangeAllowTotalChanges}
                    color="primary"
                  />
                }
                label="Allow Total Changes"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={syncML}
                    onChange={handleChangeAllowMLChanges}
                    color="primary"
                  />
                }
                label="Allow Money Line Changes"
              />
            </FormGroup>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={syncSpreadOdds}
                    onChange={handleChangeAllowSpreadOddsChanges}
                    color="primary"
                  />
                }
                label="Allow Point-Spread Odd Changes"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={syncTotalOdds}
                    onChange={handleChangeAllowTotalOddsChanges}
                    color="primary"
                  />
                }
                label="Allow Total Odds Changes"
              />
            </FormGroup>
          </form>
        </React.Fragment>
      )}
      <DialogActions>
        {isLoading ? (
          <Loader height={100} width={100}></Loader>
        ) : (
          <div>
            <Button
              color="inherit"
              startIcon={<CancelIcon />}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
              onClick={handleOk}
            >
              Ok
            </Button>
          </div>
        )}
      </DialogActions>
    </Dialog>
  );
}
